/* «Заполнить из описания» без React (план вехи 3, mcard-infog K-PX): POST /app/infog/extract (docs/03-api.md §7.6) — описание товара →
   название, преимущества и характеристики только по фактам текста; бесплатно, без заказа. Одно ядро для родного листа
   (ProductExtractSheet.tsx) и сервера движка шаблона (features/infog/infog-server.ts): те же пределы, тот же разбор ответа и те же
   тексты отказов. Пока Backend не публикует метод, отказ говорит, что разбор недоступен, и ничего не придумывает. */
import { api } from '../../api';
import { ApiError } from '../../api/client';
import { record, rows, text } from '../studio/studio-content';
import type { SpecRow } from './product-model';

export type ExtractKind = 'infog' | 'mcard';
export interface ExtractFound {
  name: string;
  advantages: string[];
  specs: SpecRow[];
}
/** Сколько знаков описания нужно экрану, чтобы искать */
export const EXTRACT_MIN: Readonly<Record<ExtractKind, number>> = { infog: 40, mcard: 30 };
/** Ответ сервера без фактов о товаре */
export const EXTRACT_EMPTY = 'В описании не нашлось фактов о товаре. Добавьте подробности.';

/** Разбор ответа: название до 60 знаков, до 6 преимуществ, до 8 характеристик (пары без ключа или значения не берутся) */
export function extractAnswer(raw: unknown): ExtractFound {
  const value = record(raw);
  return {
    name: text(value.name).slice(0, 60),
    advantages: (Array.isArray(value.advantages) ? value.advantages.map(text) : []).filter(Boolean).slice(0, 6),
    specs: rows(value.specs)
      .map(row => [text(row.key), text(row.value)] as SpecRow)
      .filter(([key, item]) => key && item)
      .slice(0, 8),
  };
}
/** В ответе нет ни названия, ни преимуществ */
export const extractEmpty = (found: ExtractFound) => !found.name && !found.advantages.length;

/** Запрос разбора (описание обрезано по краям). Бросает ошибку запроса — её текст даёт extractFailure */
export async function extractProduct(description: string, kind: ExtractKind, signal?: AbortSignal): Promise<ExtractFound> {
  return extractAnswer(await api.request<unknown>('/app/infog/extract', { method: 'POST', body: { description: description.trim(), for: kind }, signal }));
}
/** Текст отказа разбора (русская строка; перевод — uiText при показе) */
export function extractFailure(failure: unknown): string {
  return failure instanceof ApiError && failure.status === 422
    ? failure.message || 'Проверьте описание: сервер его не принял.'
    : failure instanceof ApiError && [404, 405, 501].includes(failure.status)
      ? 'Разбор описания пока недоступен. Заполните поле вручную.'
      : 'Не удалось разобрать описание. Попробуйте ещё раз.';
}
